// extracted by mini-css-extract-plugin
export default {"button":"ik-z","reviewSort":"jk-z"};